<template lang="pug">
v-container
  br
  v-snackbar(
    v-model="snackbar"
    color="primary"
    :timeout="2000") {{ message }}      
  v-row
    v-col(style="width: 100% !important; text-align: center") 
      h1 {{ $t("profile")}}
      span {{ $t("updateyouraccountdata")}}  
    //- v-html(style="width: 100% !important; text-align: center") 
    //-   h1 {{ $t("profile")}}
    //-   span {{ $t("updateyouraccountdata")}}
  v-divider.mt-5
  v-row.mt-8.ml-10.mr-10
    v-col.ml-10.mr-10
      v-form(        
        ref="form"
        v-model="valid"
        )
        v-row(justify="space-between")
          v-col.col-1
            v-icon(color="primary", x-large) mdi-account-circle
          v-col.col-11.pt-5.pl-8
            h3 {{ $t("personaldata")}}
        v-row.pl-16
          v-col
            v-text-field(
              v-model="user.name",
              :rules="nameRules"
              v-bind:label='$t("requirednames")'
            )

          v-col
            v-text-field(
              v-model="user.firstName",
              :rules="lastNameRules"
              v-bind:label='$t("requiredlastname")'
            )
        v-row.pl-16
          v-col
            v-text-field(
              v-model="user.email",          
              readonly                    
              v-bind:label='$t("requiredemail")'
            )

        v-row.pl-16
          v-col
            v-text-field(
              v-model="user.company",          
              v-bind:label='$t("companyname")'
            )

        v-row(justify="space-between")
          v-colv-col.col-1
            v-icon(color="primary", x-large) mdi-lock
          v-col.col-11.pt-5.pl-8
            h3 {{ $t("updatepassword")}}

        v-row.pl-16
          v-col
              v-text-field(
                v-model="user.password",
                type="password",
                
                v-bind:label='$t("newpassword")'
              )
        v-row.pl-16
            v-col
              v-text-field(
                v-model="repeatpassword",
                type="password",
                :rules="passwordRules"
                v-bind:label='$t("repeatpassword")'
                ref="repeatpassword"
              )

        v-row(justify="space-between")
          v-col.col-1
            v-icon(color="primary", x-large) mdi-chat
          v-col.col-11.pt-5.pl-8
            h3 {{ $t("preferedlanguage")}}
        v-row.pl-16
          v-col
            v-radio-group.nufi-radio-group(
              row,
              label="",
              v-model="user.locale",
              style="margin: 0 auto 0 auto"
            )
              v-radio(v-bind:label='$t("spanish")', light, value="es")
              v-radio(v-bind:label='$t("english")', value="en")  
        v-row.pl-16
          v-btn(small,color="primary",class="ma-2 white--text" @click="update" :loading="loading")  {{ $t("savechanges")}}              
    v-col.ml-10.mr-10
      v-form(        
        ref="form"
        v-model="valid")
        v-row(justify="space-between")
          v-col.col-1
            // v-icon(color="primary", x-large) mdi-account-circle
            img.card(src="@/assets/card.png")
          v-col.col-11.pt-5.pl-8
            h3 {{ $t("tdc")}}
        v-row.pl-16
          v-col
            card(:editing="editingCard" ref="card" @updated="editingCard = false")
        v-row.pl-16
          v-col
            v-btn(small,color="primary" v-if="!editingCard" @click="editingCard = true").white--text  {{ $t("update")}}
            v-btn(small,color="primary" v-if="editingCard" @click="addCard").white--text  {{ $t("accept")}}
            v-btn(small,color="primary" v-if="editingCard" @click="editingCard = false").white--text.ml-2  {{ $t("cancel")}}
</template>
<script>
import card from '@/components/customer-card.vue';
export default {
  components: {
    card
  },
  data() {
    const vm = this;
    return {
      user : {
        name: null,
        email : null,
        locale: null,
        company: null,
        password: null
      },
      carddefault: "0",
      repeatpassword: null,
      valid: false,
      loading: false,
      message: null,
      snackbar: false,
      editingCard: false,
      nameRules: [
        v => !!v || vm.$t('providenames')
      ],
      lastNameRules: [
        v => !!v || vm.$t('providelastname')
      ],
      passwordRules: [
        v => {          
          return vm.user.password === v || vm.$t('samepassword')
        }
      ]
    }
  },
  created() {
    this.user = Object.assign({}, this.$store.state.user, {password: null});    
    //this.user.password = null;
  },
  methods: {
    update() {
      this.$refs.form.validate();
      if (this.valid && this.user.password === this.repeatpassword) {
        this.loading = true;
        this.$store.dispatch("userUpdate", this.user).then(response => {            
          if(response.status === 200) {
            this.message = "Se actualizo tu perfil."
            this.snackbar = true;
            this.$store.commit("SET_USER", response.data);
            this.user = Object.assign({}, this.$store.state.user, {password: null});            
            this.$i18n.locale = this.user.locale;
            this.repeatpassword = null;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      } else {
        this.$refs.repeatpassword.focus();
      }
    },
    addCard() {
      this.$refs.card.addCard();
    }
  },
}
</script>
<style scoped>
.card {
  width: 40px;
  height: 34px;
}
</style>